/**
 * @generated SignedSource<<c6b6f37ea09d17873b2380f1fe20c29c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileTooltip_viewer$data = {
  readonly nftBenignNeglect: boolean | null;
  readonly " $fragmentType": "NftItemTileTooltip_viewer";
};
export type NftItemTileTooltip_viewer$key = {
  readonly " $data"?: NftItemTileTooltip_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTooltip_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileTooltip_viewer",
  "selections": [
    {
      "alias": "nftBenignNeglect",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftBenignNeglect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "32ea1567296c328676ce8ae1aa73e9e0";

export default node;
